import { CommonModule } from '@angular/common';
import { ApplicationRef, Component, OnInit, Renderer2 } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { BrowserStorageService } from './shared/services/common/browser-storage.service';
import { NetworkService } from './shared/services/network/network.service';
import { UserService } from './shared/services/user.service';
import { routeTransitionAnimations } from './utils/animations';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routeTransitionAnimations],
})
export class AppComponent implements OnInit {
  ready = false;
  title = 'XDGE Sports';

  constructor(
    private _userService: UserService,
    private _storageService: BrowserStorageService,
    private _networkService: NetworkService,
    private appRef: ApplicationRef,
    private _renderer: Renderer2,
  ) {
    this._userService.savedUser ? this._userService.getUserDetails() : null;
    if (this._storageService.getBrowser()) {
      this.ready = true;
      console.log('Hydration Ready');
      this.addDynamicLink((environment as any).BaseUrl, 'link');
      this.addDynamicLink('https://cdn.ckeditor.com/4.19.1/full-all/ckeditor.js', 'script');
    }
  }
  ngOnInit(): void {
    this.title = 'XDGE Sports';
    setTimeout(() => {
      this.appRef.isStable.subscribe((stable) => {
        if (stable) {
          console.log('Application is stable');
        }
      });
    }, 5000);
    this.monkeyPatch();
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData;
  }

  monkeyPatch() {
    const originalConsoleLog = console.log;
    console.log = function (message?: any, ...optionalParams: any[]) {
      const suppressMsg = "Option 'items' in your options is equal to the number of slides. So the navigation got disabled";
      if (typeof message === 'string' && message.includes(suppressMsg)) {
        return;
      }
      originalConsoleLog.apply(console, [message, ...optionalParams]);
    };
  }

  addDynamicLink(url: string, tag: string): void {
    const link = this._renderer.createElement(tag);
    tag === 'script' ? (link.type = 'text/javascript') : '';
    tag === 'script' ? (link.src = url) : (link.href = url);
    tag === 'script' ? (link.async = true) : (link.rel = 'preconnect');
    // link.rel = 'preconnect';
    // link.href = url;
    this._renderer.appendChild(document.head, link);
  }
}
